import config from 'shared/config';
import connector from 'api/http';
import { ApiData, Config } from 'scenes/common/types';
import { makeApiSuccess } from 'scenes/common/helpers/apiData';
import { unmarshalConfigResponse } from './marshaller';
import { defaultConfig } from './defaults';

const api = (baseUrl: string = config.baseUrls.BFF_BASE_URL) => {
  const server = connector(baseUrl);

  return {
    getConfig: (): Promise<ApiData<Config>> =>
      server
        .get('/referencedata/system/config')
        .then(unmarshalConfigResponse)
        .catch(() => makeApiSuccess(defaultConfig)),
  };
};

export default api;
